import React from "react";

import { cn } from "utils/cn";

export interface TabItem {
  id: string;
  label: string;
  className?: string;
}

interface TabItemsProps {
  tabs: TabItem[];
  activeTab: string;
  wrapperClassName?: string;
  onTabClick: (id: string) => void;
}

export const TabItems: React.FC<TabItemsProps> = ({ tabs, activeTab, wrapperClassName, onTabClick }) => {
  return (
    <div className={cn("relative flex h-[44px] w-full gap-2", wrapperClassName)}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            role="tab"
            aria-selected={isActive}
            aria-controls={`panel-${tab.id}`}
            id={`tab-${tab.id}`}
            tabIndex={isActive ? 0 : -1}
            key={tab.id}
            onClick={() => onTabClick(tab.id)}
            className={cn(
              "flex w-[210px] cursor-pointer items-center justify-center rounded-t-sm py-6",
              {
                "bg-footer-background": !isActive,
                "is-active bg-white": isActive,
              },
              tab.className
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};
